export const fontFamilies = {
  serif: "'Newsreader', 'Times New Roman', serif",
  serifEd: "'Spectral', 'Newsreader', serif",
  sans: "'Onest', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  mono: "'DM Mono', ui-monospace, SFMono-Regular, Menlo, Consolas, monospace",
} as const;

export const fontWeights = {
  light: 300,
  regular: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
} as const;

export const fontSizes = {
  monoXs: '10px',
  monoSm: '11px',
  monoMd: '12px',
  uiSm: '13px',
  ui: '14px',
  uiLg: '15px',
  bodySm: '15px',
  body: '16px',
  bodyLg: '18px',
  bodyXl: '20px',
  hXs: '22px',
  hSm: '24px',
  hMd: '32px',
  hLg: '44px',
  displaySm: '56px',
  displayMd: '72px',
  displayLg: '96px',
  displayXl: '140px',
} as const;

export const lineHeights = {
  tight: 1.05,
  snug: 1.2,
  body: 1.5,
  relaxed: 1.55,
  loose: 1.65,
} as const;

export const letterSpacings = {
  xtight: '-0.035em',
  tight: '-0.025em',
  snug: '-0.015em',
  normal: '0',
  wide: '0.04em',
  wider: '0.08em',
  widest: '0.14em',
} as const;

export type Typography = {
  fontFamilies: typeof fontFamilies;
  fontWeights: typeof fontWeights;
  fontSizes: typeof fontSizes;
  lineHeights: typeof lineHeights;
  letterSpacings: typeof letterSpacings;
};

export const typography: Typography = {
  fontFamilies,
  fontWeights,
  fontSizes,
  lineHeights,
  letterSpacings,
};
